// Links to this site that were pasted into content. A chat opens them where
// the reader already is, instead of sending them out to a browser to load the
// same app a second time.

/** What an in-app path points at, as far as a preview card can show it. */
export type InternalTarget =
  | { kind: 'post'; postId: string }
  | { kind: 'space'; slug: string }
  | { kind: 'user'; username: string }
  | { kind: 'page' };

const bareHost = (hostname: string) => hostname.replace(/^www\./, '');

/**
 * The path of a link into this site, or null when it goes anywhere else.
 * By host, not prefix: `startsWith` also matches factiii.com.evil.net.
 */
export const internalPath = (href: string, siteUrl: string): string | null => {
  try {
    const url = new URL(href);
    const site = new URL(siteUrl);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    if (bareHost(url.hostname) !== bareHost(site.hostname)) return null;
    if (url.port !== site.port) return null;
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
};

/** Which thing a path from `internalPath` opens. Anything else is a page. */
export const internalTarget = (path: string): InternalTarget => {
  const [first, second, third] = path
    .split(/[?#]/)[0]
    .split('/')
    .filter(Boolean)
    .map(decodeURIComponent);
  if (!second || third) return { kind: 'page' };
  if (first === 'post') return { kind: 'post', postId: second };
  if (first === 's') return { kind: 'space', slug: second };
  if (first === 'user') return { kind: 'user', username: second };
  return { kind: 'page' };
};
